import AppraisalForm from './AppraisalForm/App.vue';
import Banner from './Banner/App.vue';
import Bonus from './Bonus/App.vue';
import Buyout from './Buyout/App.vue';
import OnlineBuyoutOnly from './OnlineBuyoutOnly/App.vue';
import ContractForm from './ContractForm/App.vue';
import DeviceFinder from './DeviceFinder/App.vue';
import DeviceState from './DeviceState/App.vue';
import DeviceSummary from './DeviceSummary/App.vue';
import Faq from './Faq/App.vue';
import HowItWorks from './HowItWorks/App.vue';
import TextBlock from './TextBlock/App.vue';
import LoginForm from './LoginForm/App.vue';
import LogRegSwapper from './LogRegSwapper/App.vue';
import Partners from './Partners/App.vue';
import ErrorMessage from './ErrorMessage/ErrorMessage';
import AdditionalInfoForm from './AdditionalInfoForm/App';
import DynamicInput from "./AppraisalForm/DynamicInput";
import SanitizeMixin from '../../mixins/buyout/sanitize';

export const Components = {
	AppraisalForm,
	AdditionalInfoForm,
	Banner,
	Bonus,
	Buyout,
	OnlineBuyoutOnly,
	ContractForm,
	DeviceFinder,
	DeviceState,
	DeviceSummary,
	Faq,
	HowItWorks,
	TextBlock,
	LoginForm,
	LogRegSwapper,
	Partners,
	ErrorMessage,
	DynamicInput
}

export {
	AppraisalForm,
	AdditionalInfoForm,
	Banner,
	Bonus,
	Buyout,
	OnlineBuyoutOnly,
	ContractForm,
	DeviceFinder,
	DeviceState,
	DeviceSummary,
	Faq,
	HowItWorks,
	TextBlock,
	LoginForm,
	LogRegSwapper,
	Partners,
	ErrorMessage,
	DynamicInput
}
